const MIB = 1024 * 1024;
const DEFAULT_UPLOAD_CHUNK_MB = 64;
const DEFAULT_UPLOAD_PARALLELISM = 4;
const MIN_UPLOAD_CHUNK_MB = 8;
const MAX_UPLOAD_CHUNK_MB = 96;
const MIN_UPLOAD_PARALLELISM = 1;
const MAX_UPLOAD_PARALLELISM = 6;

export function uploadChunkSize(fileSizeBytes: number, configuredChunkMb = import.meta.env.VITE_UPLOAD_CHUNK_MB): number {
  const parsedChunkMb = Number(configuredChunkMb);
  const requestedChunkMb =
    Number.isFinite(parsedChunkMb) && parsedChunkMb > 0 ? parsedChunkMb : DEFAULT_UPLOAD_CHUNK_MB;
  const clampedChunkMb = Math.min(MAX_UPLOAD_CHUNK_MB, Math.max(MIN_UPLOAD_CHUNK_MB, requestedChunkMb));
  const chunkBytes = Math.round(clampedChunkMb * MIB);

  if (fileSizeBytes > 0) {
    return Math.min(chunkBytes, fileSizeBytes);
  }

  return chunkBytes;
}

export function uploadParallelism(configuredParallelism = import.meta.env.VITE_UPLOAD_PARALLELISM): number {
  const parsedParallelism = Number(configuredParallelism);
  const requestedParallelism =
    Number.isFinite(parsedParallelism) && parsedParallelism > 0 ? Math.round(parsedParallelism) : DEFAULT_UPLOAD_PARALLELISM;
  return Math.min(MAX_UPLOAD_PARALLELISM, Math.max(MIN_UPLOAD_PARALLELISM, requestedParallelism));
}
